<template>
  <div class="step-progress">
    <div class="steps">
      <div
        v-for="(step, index) in stepList"
        :key="index"
        class="step"
        :class="{ active: index + 1 === currentStep, completed: index + 1 < currentStep }"
      >
        <div class="step-box">
          <div class="circle">
            <template v-if="index + 1 < current">
              <img :src="checkImg" width="20" height="20" />
            </template>
            <template v-else>{{ index + 1 }}</template>
          </div>
          <div class="label">{{ step }}</div>
        </div>
      </div>
    </div>
    <div class="progress-bar">
      <div class="progress" :style="{ width: progressWidth + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from 'vue'

export default {
  name: 'StepProgressBar',
  props: {
    steps: {
      type: Array,
      required: true
    },
    current: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const { steps: stepList, current: currentStep } = toRefs(props)

    const progressWidth = computed(() => {
      if (stepList.value.length <= 1) return 0
      return ((currentStep.value - 1) / (stepList.value.length - 1)) * 100
    })

    const checkImg = new URL('@/assets/img/svg/check.svg', import.meta.url).href

    return {
      stepList,
      currentStep,
      progressWidth,
      checkImg
    }
  }
}
</script>

<style scoped lang="scss">
.step-progress {
  width: 100%;
}

.steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.step {
  flex: 1;
  display: flex;
  justify-content: center;

  .step-box {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px 8px 8px;
    background-color: #f6f7fb;
    border-radius: 9px;
  }

  .circle {
    background-color: white;
    color: #23262c;
    font-weight: bold;
    border-radius: 6px;
    width: 24px;
    height: 24px;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .label {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
  }

  &.active .step-box {
    .circle {
      background-color: #23262c;
      color: #ffffff;
    }

    .label {
      color: #000000;
      font-weight: bold;
    }
  }

  &.completed .step-box {
    .circle {
      background-color: #35bc8d;
      color: #ffffff;
    }
  }
}

.progress-bar {
  height: 4px;
  background-color: #d1d5db;
  border-radius: 2px;
  overflow: hidden;

  .progress {
    height: 100%;
    background-color: #10b981;
    transition: width 0.3s ease;
  }
}
</style>
